export const CREDIT_DETAILS_PATH = "/profile#credits";
export const CONTACT_SALES_URL = "https://www.researchly.at/kontakt";
